import { Theme } from '@mui/material/styles/createTheme';
import makeStyles from '@mui/styles/makeStyles';
import createStyles from '@mui/styles/createStyles';

export const useGroupsStyles = makeStyles((theme: Theme) =>
  createStyles({
    accordionItem: {
      border: `1px solid ${theme.palette.gray.extraLightGray}`,
      borderRadius: 5,
      boxShadow: '0px 5px 7px rgba(0, 0, 0, 0.05)',
    },
    downloadedBlockWrapper: {
      padding: '10px 0',
      marginLeft: 30,
      position: 'relative',
      borderBottom: `1px solid #EDECEF`,
      '&:last-child': {
        border: 0,
      },
      '&::before': {
        position: 'absolute',
        display: 'block',
        content: '""',
        width: 5,
        height: 5,
        borderRadius: '50%',
        backgroundColor: '#C4C4C4',
        left: -12,
        top: 'calc(50% - 2.5px)',
      },
      '&::after': {
        position: 'absolute',
        display: 'block',
        content: '""',
        width: 1,
        height: 45,
        backgroundColor: '#C4C4C4',
        left: -10,
        top: '50%',
      },
      '&:last-child::after': {
        top: -17,
        height: 40,
      },
    },
    downloadedBlock: {
      display: 'flex',
      flexWrap: 'wrap',
      alignItems: 'center',
    },
    actionIcon: {
      cursor: 'pointer',
      marginLeft: 16,
      color: theme.palette.blue.accentBlue,
      transition: '0.2s ease all',
      '&:hover': {
        backgroundColor:"#D2D3D6",
        color: theme.palette.primaryColor,
      },
      '& a': {
        '&:hover': {
          color: theme.palette.primaryColor,
        },
      },
    },
    sharepointLinkIcon: {
      color: theme.palette.blue.accentBlue,
    },
    deleteIcon: {
      marginLeft: 16,
      color: theme.palette.basic.yellow,
    },
    dateText: {
      marginBottom: 0,
      [theme.breakpoints.down('sm')]: {
        marginBottom: '8px'
      }
    }
  })
);
